import React from 'react';
import { bool, func, number, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

// Import modules from this directory
import css from './BiddingForm.module.css';
import { injectIntl, useIntl } from 'react-intl';
import appSettings from '../../../config/settings';
import { propTypes } from '../../../util/types';
import FieldCurrencyInput from '../../FieldCurrencyInput/FieldCurrencyInput';
import Button from '../../Button/Button';
import Form from '../../Form/Form';
import { getPriceValidators } from '../../../containers/EditListingPage/EditListingWizard/EditListingPricingPanel/EditListingPricingForm';

export const BiddingFormComponent = props => (
  <FinalForm
    {...props}
    render={formRenderProps => {
      const {
        formId,
        autoFocus,
        className,
        disabled,
        ready,
        handleSubmit,
        marketplaceCurrency,
        listingMinimumPriceSubUnits,
        invalid,
        pristine,
        updateInProgress,
        fetchErrors,
        values,
      } = formRenderProps;
      const intl = useIntl();
      const priceValidators = getPriceValidators(
        listingMinimumPriceSubUnits,
        marketplaceCurrency,
        intl
      );

      const classes = classNames(css.root, className);
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress;
      const { updateListingError, showListingsError } = fetchErrors || {};

      return (
        <Form onSubmit={handleSubmit} className={classes}>
          {updateListingError ? (
            <p className={css.error}>
              <FormattedMessage id="BiddingForm.updateFailed" />
            </p>
          ) : null}
          {showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="BiddingForm.showListingFailed" />
            </p>
          ) : null}
          <FieldCurrencyInput
            id={`${formId}biddingPrice`}
            name="biddingPrice"
            className={css.input}
            autoFocus={autoFocus}
            label={intl.formatMessage({ id: 'BiddingForm.biddingPriceLabel' })}
            placeholder={intl.formatMessage({ id: 'BiddingForm.biddingPricePlaceholder' })}
            currencyConfig={appSettings.getCurrencyFormatting(marketplaceCurrency)}
            validate={priceValidators}
          />

          <Button
            className={css.submitButton}
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabled}
          >
            {intl.formatMessage({ id: 'BiddingForm.submitBid' })}
          </Button>
        </Form>
      );
    }}
  />
);

BiddingFormComponent.defaultProps = {
  fetchErrors: null,
  listingMinimumPriceSubUnits: 0,
  formId: 'BiddingForm',
};

BiddingFormComponent.propTypes = {
  formId: string,
  onSubmit: func.isRequired,
  marketplaceCurrency: string.isRequired,
  listingMinimumPriceSubUnits: number,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(injectIntl)(BiddingFormComponent);
